import { useRouteLoaderData } from 'react-router'

import { ProviderRootLoaderData } from '~/portal/routes/sp-admin/loader'
import { ConsumerLoaderData } from '~/portal/types/portal'
import { useHostname } from '~/shared/utils/environment'

interface UsePortalUrlOptions {
  appendSlash: boolean
}
export const usePortalUrl = (options: UsePortalUrlOptions = { appendSlash: true }): { hostname: string } => {
  const hostname = useHostname()
  const adminLoaderData = useRouteLoaderData<ProviderRootLoaderData>('routes/sp-admin/_index')
  const consumerLoaderData = useRouteLoaderData<ConsumerLoaderData>('routes/_docs/_index')

  const { portalCustomDomain, portalSubdomain } = adminLoaderData || consumerLoaderData || {}
  const slash = options.appendSlash ? '/' : ''
  if (portalCustomDomain) {
    return { hostname: `${portalCustomDomain}${slash}` }
  }
  return { hostname: `${portalSubdomain}.${hostname}${slash}` }
}